import { render, staticRenderFns } from "./label-management.vue?vue&type=template&id=22869891&scoped=true&lang=html"
import script from "./label-management.vue?vue&type=script&lang=js"
export * from "./label-management.vue?vue&type=script&lang=js"
import style0 from "./label-management.vue?vue&type=style&index=0&id=22869891&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22869891",
  null
  
)

export default component.exports